import { ref } from "vue";

export default function useModal() {
  const isModalOpened = ref(true);
  const selectedModal = ref(null);
  const openModal = (type) => {
    isModalOpened.value = true;
    selectedModal.value = type;
  };

  const closeModal = () => {
    isModalOpened.value = false;
    selectedModal.value = null;
  };
  return [isModalOpened, selectedModal, openModal, closeModal];
}
